import { render, staticRenderFns } from "./nav-breadcrumb.vue?vue&type=template&id=2b1d2fb9"
import script from "./nav-breadcrumb.vue?vue&type=script&lang=js"
export * from "./nav-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./nav-breadcrumb.vue?vue&type=style&index=0&id=2b1d2fb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports